module.exports = __webpack_public_path__ + "img/upload.30fec57d.svg";